/**
 * useToast Hook
 * Custom hook for toast notifications using CSS variables
 */
import toast from 'react-hot-toast';

/**
 * Get CSS variable value
 */
const getCSSVariable = (variable) => {
  if (typeof window === 'undefined') return null;
  return getComputedStyle(document.documentElement)
    .getPropertyValue(variable)
    .trim();
};

/**
 * Toast utility functions using CSS variables
 */
export const useToast = () => {
  const showSuccess = (message, options = {}) => {
    const successColor = getCSSVariable('--color-success') || '#16A34A';
    return toast.success(message, {
      duration: 2000,
      position: 'top-center',
      style: {
        background: successColor,
        color: '#fff',
        borderRadius: '8px',
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: '500',
      },
      ...options,
    });
  };

  const showError = (message, options = {}) => {
    const errorColor = getCSSVariable('--color-error') || '#DC2626';
    return toast.error(message, {
      duration: 3000,
      position: 'top-center',
      style: {
        background: errorColor,
        color: '#fff',
        borderRadius: '8px',
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: '500',
      },
      ...options,
    });
  };

  const showInfo = (message, options = {}) => {
    const textSecondary = getCSSVariable('--color-text-secondary') || '#9CA3AF';
    const bgCard = getCSSVariable('--color-bg-card') || '#161C33';
    return toast(message, {
      duration: 2000,
      position: 'top-center',
      icon: 'ℹ️',
      style: {
        background: bgCard,
        color: textSecondary,
        borderRadius: '8px',
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: '500',
        border: `1px solid ${getCSSVariable('--color-border') || '#1F2747'}`,
      },
      ...options,
    });
  };

  return {
    showSuccess,
    showError,
    showInfo,
  };
};

export default useToast;
